var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"box-sizing":"border-box","padding-left":"16px","height":"1px","width":"100%"}},[_c('div',{staticStyle:{"height":"1px","background":"#e5e5e5"}})])
}]

export { render, staticRenderFns }